(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/host-flerp.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/host-flerp.js');
"use strict";


const HostFlerp = _ref => {
  let {
    hostName
  } = _ref;
  return React.createElement("div", {
    className: "bingo-card-desktop-host-flerp"
  }, React.createElement("span", {
    className: "bingo-card-desktop-host-flerp__title"
  }, "Chattv\xE4rd"), React.createElement("span", {
    className: "bingo-card-desktop-host-flerp__name"
  }, hostName));
};
setGlobal('svs.bingo_react.components.bingoCard.HostFlerp', HostFlerp);

 })(window);